import { useState } from 'react';
import { Box, Skeleton, SxProps, Theme } from '@mui/material';

interface ImageItemProps {
    alt: string;
    className?: string;
    onClick: () => void;
    src: string;
    sx?: SxProps<Theme>;
}

export const ImageItem = (props: ImageItemProps) => {
    const { alt, className, onClick, src, sx } = props;

    const [hasLoaded, setHasLoaded] = useState(false);

    return (
        <>
            {!hasLoaded && <Skeleton className={className} data-testid="loadingSkeleton" variant="rectangular" />}
            <Box alt={alt} component="img" onClick={onClick} onLoad={() => setHasLoaded(true)} src={src} sx={sx} />
        </>
    );
};
